/* INTEGY V594 release: V41 data/search/filter refresh + generalized first-paint guard.
   Preserves V593 route canonicalization and stock verification behavior.
   V593 keeps V592/V577 filtering unchanged and adds an independent head-level fail-safe so a release-asset load failure can never leave an indexed stock grid hidden indefinitely.
   Shopify raw stock markup remains untrusted there, so the native grid stays visually suppressed until V577 has rendered and live-verified its replacement. */
(function(){
  'use strict';
  function v626Root(){try{var r=window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root;if(r)return r.charAt(r.length-1)==='/'?r:r+'/'}catch(e){}return'/'}
  var CANONICAL_TRAXXAS=v626Root()+'collections/hopups-for-traxxas';
  var CANONICAL_RC_TOOLS=v626Root()+'collections/rc-tools';
  var EVEREST=v626Root()+'collections/all-integy-hop-up-parts?integy_filter=for-redcat-everest-gen7-pro&integy_stock=in&sort_by=title-ascending';
  window.IntegyV594=window.IntegyV593=window.IntegyV592=window.IntegyV591=window.IntegyV590=window.IntegyV589=window.IntegyV588=window.IntegyV587=window.IntegyV586=window.IntegyV585=window.IntegyV584=window.IntegyV583=window.IntegyV582=window.IntegyV581=window.IntegyV580=window.IntegyV579=window.IntegyV578=window.IntegyV577=window.IntegyV576={version:'V594',data:'V41-20260908',taxonomy:'V594-DATA41-2',cleanup:'dead-v449-v501-v550-v552-standalone-js-pruned;v567-v575-pruned-in-v581;rc-tools-stale-route-canonicalized-v584;homepage-obsolete-collection-refs-canonicalized-v585;server-rendered-nav-canonicalizer-v586;top-level-and-configurable-link-canonicalization-v587;exact-root-handle-liquid-canonicalization-v588;configurable-link-canonical-coverage-v589;remaining-collection-link-canonicalization-and-targeted-runtime-scan-v590;indexed-stock-first-paint-guard-v591;render-key-zero-result-and-count-handoff-v592;independent-head-paint-watchdog-v593;v41-search-filter-stock-refresh-and-general-filter-paint-guard-v594',collectionOwnership:'shopify-native-except-audited-indexed-stock',traxxasCanonical:'hopups-for-traxxas',traxxasStock:'indexed-candidate-live-card-verified-refill',stockFacets:'live-small-set-verified',allStock:'v41-candidate-live-card-verified-refill',allHopupsStock:'indexed-candidate-live-card-verified-refill',staleIndexedProducts:'hidden-on-live-404',everestRoute:'server-rendered-plus-runtime-fallback',rcToolsCanonical:'rc-tools'};
  document.documentElement.classList.add('integy-v576-runtime','integy-v577-runtime','integy-v580-runtime','integy-v581-runtime','integy-v582-runtime','integy-v583-runtime','integy-v584-runtime','integy-v585-runtime','integy-v586-runtime','integy-v587-runtime','integy-v588-runtime','integy-v589-runtime','integy-v590-runtime','integy-v591-runtime','integy-v592-runtime','integy-v593-runtime','integy-v594-runtime');

  /* INTEGY V634 cleanup — removed dormant V593 paint-guard owner.
     No current route adds its activation class; V594/V634 is the sole paint owner. */

  function rewriteAnchor(a){
    if(!a||!a.getAttribute)return;
    var raw=a.getAttribute('href')||'';
    if(!raw)return;
    try{
      var u=new URL(raw,location.origin);
      if(u.origin!==location.origin)return;
      // V590: canonicalize audited stock URLs before a shopper clicks them.
      // This prevents any old/native link from first loading Shopify's known-bad
      // availability universe and eliminates avoidable redraw/navigation work.
      var auditedTarget=/^\/collections\/(?:all|all-integy-hop-up-parts|hopups-for-traxxas)$/i.test(u.pathname);
      if(auditedTarget){
        var targetNative=u.searchParams.get('filter.v.availability')||'';
        var targetStock=u.searchParams.get('integy_stock')||'';
        if(targetNative==='1'||targetNative==='0'){
          targetStock=targetNative==='0'?'out':'in';
          u.searchParams.delete('filter.v.availability');
          u.searchParams.set('integy_stock',targetStock);
          a.setAttribute('href',u.pathname+(u.searchParams.toString()?'?'+u.searchParams.toString():'')+u.hash);
        } else if(targetStock==='in'||targetStock==='out'||targetStock==='all'){
          if(u.searchParams.has('filter.v.availability'))u.searchParams.delete('filter.v.availability');
          a.setAttribute('href',u.pathname+(u.searchParams.toString()?'?'+u.searchParams.toString():'')+u.hash);
        }
      }
      if(u.pathname==='/collections/hop-up-parts-for-traxxas'||u.pathname==='/collections/parts-for-traxxas'){
        u.pathname=CANONICAL_TRAXXAS;
        var native=u.searchParams.get('filter.v.availability')||'';
        if(native==='1'||native==='0'){
          u.searchParams.delete('filter.v.availability');
          u.searchParams.set('integy_stock',native==='0'?'out':'in');
        }
        a.setAttribute('href',u.pathname+(u.search?'?'+u.searchParams.toString():'')+u.hash);
        raw=a.getAttribute('href')||raw;
      }
      if(u.pathname==='/collections/all-rc-tools-tool-sets-and-accessories'){
        u.pathname=CANONICAL_RC_TOOLS;
        var toolsNative=u.searchParams.get('filter.v.availability')||'';
        var toolsStock=u.searchParams.get('integy_stock')||'';
        if(toolsStock==='out') toolsNative='0';
        else if(toolsStock==='in') toolsNative='1';
        else if(toolsStock==='all') toolsNative='';
        u.searchParams.delete('integy_stock');
        u.searchParams.delete('integy_include_sold_out');
        if(toolsNative==='0'||toolsNative==='1')u.searchParams.set('filter.v.availability',toolsNative);
        else u.searchParams.delete('filter.v.availability');
        a.setAttribute('href',u.pathname+(u.searchParams.toString()?'?'+u.searchParams.toString():'')+u.hash);
        raw=a.getAttribute('href')||raw;
      }
      var text=String(a.textContent||'').replace(/\s+/g,' ').trim().toLowerCase();
      var navContext=(a.closest&&a.closest('header,.site-header,[data-navmenu-submenu],[data-mobile-nav],[data-integy-v547-vehicle-meganav],nav'));
      var isFourTec=/4[- ]?tec/.test(text);
      if(isFourTec&&navContext){
        a.setAttribute('href',CANONICAL_TRAXXAS+'?integy_filter=1-10-4-tec-2-0-and-3-0&integy_stock=in');
        return;
      }
      var isEverest=text==='everest gen7 pro'||(/\/search$/i.test(u.pathname)&&/everest\s*gen7\s*pro/i.test(u.searchParams.get('q')||''));
      if(isEverest&&navContext){
        a.setAttribute('href',EVEREST);
      }
    }catch(e){}
  }
  var TARGET_SELECTOR=[
    'header a[href]','nav a[href]','.site-header a[href]','[data-navmenu-submenu] a[href]','[data-mobile-nav] a[href]','[data-integy-v547-vehicle-meganav] a[href]',
    'a[href*="/collections/hop-up-parts-for-traxxas"]','a[href*="/collections/parts-for-traxxas"]','a[href*="/collections/all-rc-tools-tool-sets-and-accessories"]',
    'a[href*="/collections/all?"]','a[href*="/collections/all-integy-hop-up-parts?"]','a[href*="/collections/hopups-for-traxxas?"]'
  ].join(',');
  function sweep(scope){
    var list=[];
    if(scope&&scope.matches&&scope.matches(TARGET_SELECTOR))list.push(scope);
    if(scope&&scope.querySelectorAll)list=list.concat(Array.prototype.slice.call(scope.querySelectorAll(TARGET_SELECTOR)));
    list.forEach(rewriteAnchor);
  }
  function canonicalizeCurrentPath(){
    try{
      var u=new URL(location.href),changedPath=false,changedQuery=false;
      if(u.pathname==='/collections/hop-up-parts-for-traxxas'||u.pathname==='/collections/parts-for-traxxas'){
        u.pathname=CANONICAL_TRAXXAS;changedPath=true;
      } else if(u.pathname==='/collections/all-rc-tools-tool-sets-and-accessories'){
        var currentToolsStock=u.searchParams.get('integy_stock')||'';
        var currentToolsNative=u.searchParams.get('filter.v.availability')||'';
        if(currentToolsStock==='out')currentToolsNative='0';
        else if(currentToolsStock==='in')currentToolsNative='1';
        else if(currentToolsStock==='all')currentToolsNative='';
        u.searchParams.delete('integy_stock');
        u.searchParams.delete('integy_include_sold_out');
        if(currentToolsNative==='0'||currentToolsNative==='1')u.searchParams.set('filter.v.availability',currentToolsNative);
        else u.searchParams.delete('filter.v.availability');
        u.pathname=CANONICAL_RC_TOOLS;changedPath=true;
      }
      var auditedStock=/^\/collections\/(?:all|all-integy-hop-up-parts|hopups-for-traxxas)$/i.test(u.pathname);
      var native=u.searchParams.get('filter.v.availability')||'';
      var stock=u.searchParams.get('integy_stock')||'';
      if(auditedStock){
        var desired=stock;
        if(native==='1'||native==='0')desired=native==='0'?'out':'in';
        if(desired!=='out'&&desired!=='all')desired='in';
        if(u.searchParams.has('filter.v.availability')){u.searchParams.delete('filter.v.availability');changedQuery=true;}
        if(u.searchParams.get('integy_stock')!==desired){u.searchParams.set('integy_stock',desired);changedQuery=true;}
      }
      if(changedPath){
        // A true collection-handle canonicalization needs one navigation.
        location.replace(u.pathname+(u.searchParams.toString()?'?'+u.searchParams.toString():'')+u.hash);return true;
      }
      if(changedQuery&&history&&history.replaceState){
        // V590: stock-mode canonicalization stays in-place; audited stock links are also rewritten before click.
        history.replaceState(history.state,'',u.pathname+(u.searchParams.toString()?'?'+u.searchParams.toString():'')+u.hash);
      }
      return false;
    }catch(e){return false;}
  }
  if(canonicalizeCurrentPath())return;
  function boot(){sweep(document);if(window.MutationObserver){var t=0;new MutationObserver(function(ms){clearTimeout(t);t=setTimeout(function(){ms.forEach(function(m){Array.prototype.forEach.call(m.addedNodes||[],function(n){if(n.nodeType===1)sweep(n);});});},60);}).observe(document.documentElement,{childList:true,subtree:true});}}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
}());

/* V725: removed the display-Type rewrite observer. Filter classification is unchanged. */

/* V576 consolidation: preserve V552 Traxxas scale-integrity guard without a separate release asset. */
/* INTEGY V552 — global scale-integrity release owner.
   V552 promotes scale to a verified RC-vehicle attribute for All Integy and
   carries forward the Traxxas scale-chip safety contract from V551. */
(function(){'use strict';if(window.IntegyV552Release)return;
var TRAXXAS_ALLOWED={'1-5':1,'1-6':1,'1-7':1,'1-8':1,'1-10':1,'1-16':1,'1-18':1};
function pathHandle(){try{var m=location.pathname.match(/^\/collections\/([^/?#]+)/);return m?m[1]:''}catch(e){return''}}
function isTraxxas(h){return /^(?:hop-up-parts-for-traxxas|hopups-for-traxxas|parts-for-traxxas|traxxas)$/.test(h||pathHandle())}
function scaleFrom(el){var h=(el.getAttribute('data-tag-handle')||'').toLowerCase();if(/^1-\d{1,2}$/.test(h))return h;try{var u=new URL(el.href,location.origin),v=u.searchParams.get('integy_filter')||'';var m=v.match(/(?:^|\+)(1-\d{1,2})(?:\+|$)/);if(m)return m[1]}catch(e){}return''}
function sweep(){var h=pathHandle();document.documentElement.classList.add('integy-v552','integy-v552-scale-integrity');if(!isTraxxas(h))return;Array.prototype.slice.call(document.querySelectorAll('a[data-tag-handle],a.integy-v27-filter-chip')).forEach(function(a){var s=scaleFrom(a);if(s&&/^1-\d{1,2}$/.test(s)&&!TRAXXAS_ALLOWED[s]){a.hidden=true;a.setAttribute('aria-hidden','true');a.setAttribute('data-integy-v552-invalid-traxxas-scale','true')}})}
function boot(){sweep();if(window.MutationObserver){var t=0;new MutationObserver(function(){clearTimeout(t);t=setTimeout(sweep,60)}).observe(document.body,{childList:true,subtree:true})}}
window.IntegyV552Release={version:'V552',traxxasAllowedScales:Object.keys(TRAXXAS_ALLOWED),sweep:sweep};if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot()

})();

(function(){'use strict';
  /* V594: generalized atomic handoff for every custom query-filter route.
     The server/native grid is intentionally hidden only until V577 writes its
     render key. Stock-owned routes additionally wait for live verification. */
  function v594ReleasePaintGuard(reason){
    var root=document.documentElement;
    if(!root.classList.contains('integy-v594-filter-paint-guard'))return true;
    root.classList.add('integy-v594-filter-ready');
    root.classList.remove('integy-v594-filter-paint-guard','integy-v594-stock-paint-guard');
    try{
      if(window.IntegyV594PaintGuardFailsafe){window.clearTimeout(window.IntegyV594PaintGuardFailsafe);window.IntegyV594PaintGuardFailsafe=0;}
      root.setAttribute('data-integy-v594-filter-paint-release',reason||'ready');
      var grid=document.querySelector('[data-productgrid-items],.productgrid--items');
      if(grid)grid.removeAttribute('aria-busy');
    }catch(e){}
    return true;
  }
  function v594PaintGuardReady(){
    var root=document.documentElement;
    if(!root.classList.contains('integy-v594-filter-paint-guard'))return true;
    /* INTEGY V700 — the V696 live large-stock owner is authoritative and its
       row-level `available` flag is already verified Shopify data. Never require
       the legacy indexed V307/V548 settlement markers on this owner. */
    if(window.IntegyV701AllStockOwnerActive || window.IntegyV701AllStockOwner || window.IntegyV651LargeStockOwnerActive || window.IntegyV681LargeCollectionStockOwner || document.querySelector('[data-integy-v651-large-owner="true"],[data-integy-v701-all-stock-owner="true"]'))
      return v594ReleasePaintGuard('v700-large-stock-owner');
    try{
      var grid=document.querySelector('[data-productgrid-items],.productgrid--items');
      if(!grid)return false;
      if(!grid.getAttribute('data-integy-v307-key'))return false;
      /* INTEGY V634 — V307 writes its key before replacing the grid children.
         Require the explicit render latch on every custom-filter route. */
      if(grid.getAttribute('data-integy-v634-render-settled')!=='true')return false;
      if(root.classList.contains('integy-v594-stock-paint-guard')){
        /* INTEGY V634 — the V307 render key is written before live product JSON
           verification starts. Require the explicit V634 settlement latch so the
           guard cannot release in that race window or during rescue refill. */
        if(grid.getAttribute('data-integy-v634-stock-settled')!=='true')return false;
        if(grid.querySelector('[data-integy-v548-stock-verified="false"]'))return false;
      }
      return v594ReleasePaintGuard('indexed-render-ready');
    }catch(e){return false;}
  }
  function v594ArmPaintGuard(){
    var root=document.documentElement;
    if(!root.classList.contains('integy-v594-filter-paint-guard'))return;
    try{var grid=document.querySelector('[data-productgrid-items],.productgrid--items');if(grid)grid.setAttribute('aria-busy','true');}catch(e){}
    if(v594PaintGuardReady())return;
    var started=Date.now(),timer=0,observer=null;
    function check(){
      if(v594PaintGuardReady()){if(timer)clearInterval(timer);if(observer)observer.disconnect();return;}
      if(Date.now()-started>12000){
        if(timer)clearInterval(timer);if(observer)observer.disconnect();
        /* V634 fail closed: if Shopify live verification is unusually slow,
           discard unresolved cards rather than flashing stale cached stock. */
        try{
          var root=document.documentElement,grid=document.querySelector('[data-productgrid-items],.productgrid--items');
          if(root.classList.contains('integy-v594-stock-paint-guard')&&grid){
            Array.prototype.slice.call(grid.querySelectorAll('[data-product-item],.productgrid--item')).forEach(function(card){
              if(card.getAttribute('data-integy-v548-stock-verified')!=='true')card.remove();
            });
            grid.setAttribute('data-integy-v634-stock-settled','true');
            grid.setAttribute('data-integy-v634-stock-timeout','true');
            grid.classList.remove('integy-v634-stock-settling','integy-v548-live-stock-pending','integy-v576-stock-refill-pending');
            var visible=grid.querySelectorAll('[data-product-item]:not([hidden]),.productgrid--item:not([hidden])').length;
            Array.prototype.slice.call(document.querySelectorAll('[data-integy-v449-stock-status]')).forEach(function(status){status.textContent=visible+' live verified match'+(visible===1?'':'es')+' on this page';});
          }
        }catch(e){}
        v594ReleasePaintGuard('verified-only-timeout');
      }
    }
    timer=setInterval(check,80);
    if(window.MutationObserver){observer=new MutationObserver(check);observer.observe(document.documentElement,{childList:true,subtree:true,attributes:true,attributeFilter:['class','data-integy-v548-stock-verified','data-integy-v307-key','data-integy-v634-render-settled','data-integy-v634-stock-settled']});}
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',v594ArmPaintGuard,{once:true});else v594ArmPaintGuard();

  /* V595 correction: the V594 C23130 HPI suppression was invalid and is intentionally removed. */

})();
